import * as MutationTypes from '../mutation-types'

//创建Vuex实例
const state = {
  loading: false,//全局loading
  tabIndex: '',//tab下标
  tabShow: true,//tabBar是否展示
}
const mutations = {

  [MutationTypes.SET_LOADING]: (state, loading) => {
    state.loading = loading
  },
  [MutationTypes.SET_TABINDEX]: (state, tabIndex) => {
    state.tabIndex = tabIndex
  },
  [MutationTypes.SET_TABSHOW]: (state, tabShow) => {
    state.tabShow = tabShow
  }
}
const actions = {
  showBottomTab({commit}){
    commit(MutationTypes.SET_TABSHOW,true)
  },
  hideBottomTab({commit}){
    commit(MutationTypes.SET_TABSHOW,false)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



//////////////////
// WEBPACK FOOTER
// ./app/store/modules/app.js
// module id = null
// module chunks = 